isKnown